<template>
  <b-input-group>
    <b-input-group-prepend>
      <b-button variant="outline-light left-btn" @click="increase(-counter)" :disabled="value === min">
        <i class="mdi mdi-minus-circle-outline"></i>
      </b-button>
    </b-input-group-prepend>
    <b-form-input
        class="form-control"
        :value="value"
        :formatter="formatter"
        v-numeric-only
    ></b-form-input>
    <b-input-group-append>
      <b-button variant="outline-light right-btn" @click="increase(counter)" :disabled="value === max">
        <i class="mdi mdi-plus-circle-outline"></i>
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  name: "QuantityInput",
  props: {
    value: {
      default: null
    },
    min: {
      default: 0
    },
    max: {
      default: 100
    },
    counter: {
      default: 1
    }
  },
  methods: {
    increase(count) {
      if (count < 0 && this.value === this.min || count > 0 && this.value === this.max) {
        return
      }
      const newVal = this.value + count
      this.formatter(newVal)
    },
    formatter(e) {
      let val = parseInt(e)
      if (!e || e <= this.min) {
        val = this.min
      } else if (e >= this.max) {
        val = this.max
      }
      this.$emit('input', val)
      return val
    }
  },
}
</script>

<style scoped>
.left-btn {
  border-radius: 4px 0 0 4px;
  border: 1px solid #ced4da
}

.right-btn {
  border-radius: 0 4px 4px 0;
  border: 1px solid #ced4da
}
</style>